export class CommentModel {

    public user: string;
    public message: string;
    public date: string;

    constructor(obj?: any) {
        this.user     = obj && obj.user     || '';
        this.message  = obj && obj.message  || '';
        this.date     = obj && obj.date     || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/comment.model.ts